import { render, staticRenderFns } from "./MoveToGroupModal.vue?vue&type=template&id=e131e1fa&scoped=true&"
import script from "./MoveToGroupModal.vue?vue&type=script&lang=js&"
export * from "./MoveToGroupModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./MoveToGroupModal.vue?vue&type=style&index=1&id=e131e1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e131e1fa",
  null
  
)

export default component.exports